import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import TopRoutes from '../../components/dashboard/topRoutes'
import TravellerTypes from '../../components/dashboard/travellerTypes'
import TicketDetails from '../../components/dashboard/ticketDetails'

import * as actions from './actions'

import './styles.css'
import { opdbGTM } from '../../utils/pulseUtils'
import { fetchMerchantId } from '../../utils'
import ReportDownload from '../../components/dashboard/downloadReport'

class DashboardContainer extends React.Component {

  componentDidMount() {
    let merchantCode = localStorage.getItem('merchant-id');
    const merchantId = fetchMerchantId();
    this.props.setMerchantId(merchantId);
    if(merchantId) { 
      merchantCode = merchantId;
    }
    const query = merchantCode ? {merchant: merchantCode} : {};
    this.props.fetchData(query);
    opdbGTM.tabClicked('od_dashboard_tab_clicked');
  }

  render() {
    const { topRoutes, travellerTypes, otherDetails, lastUpdated, operatorInfo } = this.props;
    const isKSRTC = operatorInfo && operatorInfo.isKsrtc && operatorInfo.isKsrtc === true;
    return (
      <div className="dashboard">
        <div className="row payout-header">
          <span className="payout-header-text">Dashboard</span>
        </div>
        <div className="db-content">
          <TicketDetails lastUpdated={lastUpdated} otherDetails={otherDetails} />
          {isKSRTC && <ReportDownload />}
          <TravellerTypes travellerTypes={travellerTypes} />
          <TopRoutes topRoutes={topRoutes} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = store => ({
  topRoutes: store.dashboardReducer.topRoutes,
  travellerTypes: store.dashboardReducer.travellerTypes,
  otherDetails: store.dashboardReducer.otherDetails,
  lastUpdated: store.dashboardReducer.lastUpdated,
  operatorInfo: store.userInfoReducer.operatorInfo,
})

const mapDispatchToProps = dispatch => ({
  fetchData: (query) => dispatch(actions.fetchData(query)),
  setMerchantId: (merchantId) => dispatch(actions.setMerchantId(merchantId))
})

DashboardContainer.propTypes = {
  merchantId: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)
